import { useEffect } from 'react';

/**
 * Hook to fix accessibility issues with AnimatePresence and focusable elements
 * This ensures that aria-hidden is not applied to elements that contain focused elements
 */
export const useAccessibilityFix = () => {
  useEffect(() => {
    const handleFocusIn = () => {
      const rootElement = document.getElementById('root');

      if (rootElement && rootElement.hasAttribute('aria-hidden')) {
        // If the root has aria-hidden but contains a focused element, remove it
        rootElement.removeAttribute('aria-hidden');
      }
    };

    const handleFocusOut = () => {
      // Small delay to allow focus to settle
      setTimeout(() => {
        const rootElement = document.getElementById('root');
        if (rootElement && !document.activeElement) {
          // Only set aria-hidden if no element is focused
          const hasFocusedElement = rootElement.contains(
            document.activeElement
          );
          if (!hasFocusedElement) {
            // Don't set aria-hidden on root - let AnimatePresence handle it
            return;
          }
        }
      }, 50);
    };

    // Add event listeners
    document.addEventListener('focusin', handleFocusIn);
    document.addEventListener('focusout', handleFocusOut);

    // Cleanup
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
      document.removeEventListener('focusout', handleFocusOut);
    };
  }, []);
};
